export enum ConnextraPlace {
	Tickets = "Tickets",
	GameTracker = "GameTracker",
}

const PLACEMENTS: Record<string, Record<ConnextraPlace, string>> = {
	en: {
		[ConnextraPlace.GameTracker]: "CFL_CFL_GameTracker_GoToGameTracker_1x1",
		[ConnextraPlace.Tickets]: "CFL_CFL_GameTracker_GetTickets_1x1",
	},
	fr: {
		[ConnextraPlace.GameTracker]: "CFL_LCF_GameTracker__GoToGameTracker_1x1",
		[ConnextraPlace.Tickets]: "CFL_LCF_GameTracker_GetTickets_1x1",
	},
};
const CLIENT = "CFL";
export const buildConnextraLink = (
	url: string = "#",
	placement: ConnextraPlace,
	locale: string
) => {
	const place = PLACEMENTS[locale][placement];

	if (!place || !url.length || url === "#") {
		return url;
	}
	return `https://ssl.connextra.com/${CLIENT}/selector/click?client=${CLIENT}&placement=${place}&tclk=${url}`;
};

export const buildConnextraImpressionLink = (placement: ConnextraPlace, locale: string) => {
	const place = PLACEMENTS[locale][placement];

	if (!place) {
		return place;
	}
	return `https://ssl.connextra.com/${CLIENT}/selector/image?client=${CLIENT}&placement=${place}`;
};
